export default class TrendStatusHelper {
  static arrowColors = {
    red: "#F04545",
    green: "#2CC487",
    orange: "#DE7C08",
    brown: "#8B6914"
  };

  static directions = {
    upRight: "up-right",
    downRight: "down-right"
  };

  static statusArrows = {
    uptrend_continuation: [
      {
        direction: TrendStatusHelper.directions.upRight,
        color: TrendStatusHelper.arrowColors.green
      },
      {
        direction: TrendStatusHelper.directions.upRight,
        color: TrendStatusHelper.arrowColors.green
      }
    ],
    uptrend_return: [
      {
        direction: TrendStatusHelper.directions.downRight,
        color: TrendStatusHelper.arrowColors.orange
      },
      {
        direction: TrendStatusHelper.directions.upRight,
        color: TrendStatusHelper.arrowColors.green
      }
    ],
    uptrend_confirmation: [
      {
        direction: TrendStatusHelper.directions.upRight,
        color: TrendStatusHelper.arrowColors.orange
      },
      {
        direction: TrendStatusHelper.directions.upRight,
        color: TrendStatusHelper.arrowColors.green
      }
    ],
    uptrend_negation: [
      {
        direction: TrendStatusHelper.directions.upRight,
        color: TrendStatusHelper.arrowColors.green
      },
      {
        direction: TrendStatusHelper.directions.downRight,
        color: TrendStatusHelper.arrowColors.orange
      }
    ],
    downtrend_continuation: [
      {
        direction: TrendStatusHelper.directions.downRight,
        color: TrendStatusHelper.arrowColors.red
      },
      {
        direction: TrendStatusHelper.directions.downRight,
        color: TrendStatusHelper.arrowColors.red
      }
    ],
    downtrend_return: [
      {
        direction: TrendStatusHelper.directions.upRight,
        color: TrendStatusHelper.arrowColors.orange
      },
      {
        direction: TrendStatusHelper.directions.downRight,
        color: TrendStatusHelper.arrowColors.red
      }
    ],
    downtrend_confirmation: [
      {
        direction: TrendStatusHelper.directions.downRight,
        color: TrendStatusHelper.arrowColors.orange
      },
      {
        direction: TrendStatusHelper.directions.downRight,
        color: TrendStatusHelper.arrowColors.red
      }
    ],
    downtrend_negation: [
      {
        direction: TrendStatusHelper.directions.downRight,
        color: TrendStatusHelper.arrowColors.red
      },
      {
        direction: TrendStatusHelper.directions.upRight,
        color: TrendStatusHelper.arrowColors.orange
      }
    ]
  };

  static render(value) {
    if (!value) {
      return null;
    }

    return TrendStatusHelper.statusArrows[value] || null;
  }
}
